import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-867302b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "otc" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = {
  key: 0,
  class: "action"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "btns" }
const _hoisted_6 = { class: "selected-num" }
const _hoisted_7 = { class: "orange" }
const _hoisted_8 = { class: "card" }
const _hoisted_9 = { class: "time-area" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "交易时间", -1))
const _hoisted_11 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_order_table = _resolveComponent("order-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_FargoTable = _resolveComponent("FargoTable")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_CanceOrder = _resolveComponent("CanceOrder")!
  const _component_success = _resolveComponent("success")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_tabs, {
      modelValue: _ctx.activeName,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.activeName) = $event)),
      class: "otc-tabs",
      onTabClick: _ctx.handleClick
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: `今日订单(${_ctx.total})`,
          name: "0"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.showAction)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.name,
                        class: _normalizeClass(_ctx.actionIndex === index ? 'btn-active' : 'btn-update'),
                        onClick: ($event: any) => (_ctx.changeIndex(index))
                      }, _toDisplayString(item.name), 11, _hoisted_4))
                    }), 128)),
                    _withDirectives(_createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", {
                        class: "btn-cancel",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancelSelect && _ctx.cancelSelect(...args)))
                      }, "取消"),
                      _createElementVNode("div", {
                        class: "btn-confirm",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.confirmSelect && _ctx.confirmSelect(...args)))
                      }, "确定")
                    ], 512), [
                      [_vShow, _ctx.actionIndex === 0 || _ctx.actionIndex === 1]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("div", _hoisted_6, [
                _createTextVNode(" 已选择 "),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.orderQty), 1),
                _createTextVNode(" 项 ")
              ], 512), [
                [_vShow, _ctx.showAction]
              ]),
              _createVNode(_component_order_table, {
                data: _ctx.todayOrderList,
                "onUpdate:data": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.todayOrderList) = $event)),
                "t-header-list": _ctx.tHeaderList,
                loading: _ctx.todayLoading,
                toggleIndex: _ctx.actionIndex,
                onChangeSelect: _ctx.changeSelect
              }, null, 8, ["data", "t-header-list", "loading", "toggleIndex", "onChangeSelect"]),
              _createVNode(_component_el_pagination, {
                "popper-class": "custom-class",
                "current-page": _ctx.params.pageNo,
                "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.params.pageNo) = $event)),
                "page-size": _ctx.params.pageSize,
                "onUpdate:pageSize": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.params.pageSize) = $event)),
                "page-sizes": [10, 20, 30, 40],
                small: "",
                background: "",
                layout: "total, sizes, prev, pager, next, jumper",
                total: _ctx.total,
                onSizeChange: _ctx.handleSizeChange,
                onCurrentChange: _ctx.handleCurrentChange
              }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])
            ])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_tab_pane, {
          label: "历史成交",
          name: "1"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", null, [
                  _hoisted_10,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeOptions, (item) => {
                    return (_openBlock(), _createElementBlock("span", {
                      class: _normalizeClass(_ctx.activeIndex === item.value ? 'active' : 'btn-time'),
                      key: item.value,
                      onClick: ($event: any) => (_ctx.selectTime(item.value))
                    }, _toDisplayString(item.name), 11, _hoisted_11))
                  }), 128)),
                  (_ctx.activeIndex === 3)
                    ? (_openBlock(), _createBlock(_component_el_date_picker, {
                        key: 0,
                        modelValue: _ctx.date,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.date) = $event)),
                        type: "daterange",
                        "range-separator": "至",
                        "start-placeholder": "开始时间",
                        "end-placeholder": "结束时间",
                        onChange: _ctx.changeDate
                      }, null, 8, ["modelValue", "onChange"]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  class: "export",
                  loading: _ctx.exportLoading,
                  onClick: _ctx.exportTable
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("导出")
                  ]),
                  _: 1
                }, 8, ["loading", "onClick"])
              ]),
              _createVNode(_component_FargoTable, {
                list: _ctx.hisOrderList,
                "onUpdate:list": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.hisOrderList) = $event)),
                "t-header-list": _ctx.hisHeaderList,
                tableLoading: _ctx.hisLoading,
                id: "table"
              }, null, 8, ["list", "t-header-list", "tableLoading"]),
              _createVNode(_component_el_pagination, {
                "popper-class": "custom-class",
                "current-page": _ctx.hisParams.pageNo,
                "onUpdate:currentPage": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.hisParams.pageNo) = $event)),
                "page-size": _ctx.hisParams.pageSize,
                "onUpdate:pageSize": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.hisParams.pageSize) = $event)),
                "page-sizes": [10, 20, 30, 40],
                small: "",
                background: "",
                layout: "total, sizes, prev, pager, next, jumper",
                total: _ctx.hisTotal,
                onSizeChange: _ctx.handleSizeChange,
                onCurrentChange: _ctx.handleCurrentChange
              }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "onTabClick"]),
    _createVNode(_component_CanceOrder, {
      dialogVisible: _ctx.dialogVisible,
      "onUpdate:dialogVisible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      data: _ctx.list,
      loading: _ctx.cancelLoading,
      onConfirm: _ctx.confirmCancel
    }, null, 8, ["dialogVisible", "data", "loading", "onConfirm"]),
    _createVNode(_component_success, {
      title: "撤单",
      onConfirm: _ctx.confirmResult,
      dialogVisible: _ctx.doneFlag,
      "onUpdate:dialogVisible": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.doneFlag) = $event)),
      tradingData: _ctx.orderData
    }, null, 8, ["onConfirm", "dialogVisible", "tradingData"])
  ]))
}